import { render, staticRenderFns } from "./HonorLivePC.vue?vue&type=template&id=60e8f012&scoped=true"
import script from "./HonorLivePC.vue?vue&type=script&lang=js"
export * from "./HonorLivePC.vue?vue&type=script&lang=js"
import style0 from "./HonorLivePC.vue?vue&type=style&index=0&id=60e8f012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e8f012",
  null
  
)

export default component.exports